export default __webpack_public_path__ + "static/media/default-landscape.dbf979aa.svg";